import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ViewEncapsulation,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule, FormControl, Validators } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { TranslateModule } from '@ngx-translate/core'
import { ProjectorContainersFacade } from 'libs/gb-dashboard/presenter/data-access-projector-containers/src/lib/+state/projector-containers.facade'
import { map, take } from 'rxjs'

@Component({
  selector: 'gb-presenter-sidebar-header',
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule],
  templateUrl: './gb-presenter-sidebar-header.component.html',
  styleUrl: './gb-presenter-sidebar-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbPresenterSidebarHeaderComponent {
  @Output() updateProjectorContainerName = new EventEmitter<string>()
  @ViewChild('nameInput') nameInput!: ElementRef<HTMLInputElement>

  isEditing = false
  nameFormControl = new FormControl('', [Validators.required, Validators.minLength(1)])

  constructor(private projectorContainersFacade: ProjectorContainersFacade) {}

  projectorContainerName$ = this.projectorContainersFacade.selectedProjectorContainer$.pipe(
    map((selectedProjectorContainer) => selectedProjectorContainer?.name),
  )

  startEditing(): void {
    this.projectorContainerName$.pipe(take(1)).subscribe((name) => {
      if (name) {
        this.nameFormControl.setValue(name)
        this.isEditing = true
        // Focus the input after the view updates
        setTimeout(() => {
          if (this.nameInput?.nativeElement) {
            this.nameInput.nativeElement.focus()
            this.nameInput.nativeElement.select()
          }
        })
      }
    })
  }

  finishEditing(): void {
    if (this.nameFormControl.valid && this.nameFormControl.value) {
      const newName = this.nameFormControl.value.trim()
      if (newName) {
        this.updateProjectorContainerName.emit(newName)
      }
    }
    this.isEditing = false
  }

  cancelEditing(): void {
    this.isEditing = false
    this.nameFormControl.reset()
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.finishEditing()
    } else if (event.key === 'Escape') {
      event.preventDefault()
      this.cancelEditing()
    }
  }
}
